import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, watch } from 'vue'
import SeletorDeSituacaoDoMacon from '@/components/SeletorDeSituacaoDoMacon.vue'
import SeletorDeLojas from '@/components/SeletorDeLojas.vue'
import { CamposDoFiltroDeBusca, obterFiltroDefault, OPCOES_DE_BUSCAR_EM } from '@/shareds/sharedBusca'


const __default__ = {
	model: {
		prop: 'filtro',
	},
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FiltroDeBusca',
  props: {
	filtro: {
		type: Object as PropType<CamposDoFiltroDeBusca>,
		required: true,
	},
},
  emits: ["input", "confirma"],
  setup(__props, { emit }: { emit: ({
	(e: 'input', filtro: CamposDoFiltroDeBusca): void
	(e: 'confirma'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const mostra = ref(false)

watch(() => props.filtro, (filtro) => {
	emit('input', filtro)
})

function limpar() {
	emit('input', obterFiltroDefault())
	emit('confirma')
}

const temFiltro = computed(() => JSON.stringify(obterFiltroDefault()) !== JSON.stringify(props.filtro))

const buscarEmOptions = OPCOES_DE_BUSCAR_EM

return { __sfc: true,props, emit, mostra, limpar, temFiltro, buscarEmOptions, SeletorDeSituacaoDoMacon, SeletorDeLojas }
}

})